import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/new-design/images/submitted-review.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Send Tenant Reference", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto d-block",
  style: {"height":"250px","margin-top":"-50px"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  style: {"margin-bottom":"4px"},
  class: "form-text"
}, " Send the tenant reference to the following emails: ", -1)
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = ["disabled", "data-kt-indicator"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Send", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Sending... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_tag = _resolveComponent("input-tag")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialog) = $event))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_input_tag, {
          separators: [','],
          regex: _ctx.emailValidRegex,
          unique: true,
          modelValue: _ctx.emails,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emails) = $event)),
          color: "#F7ECFA",
          "text-color": "#990ABD",
          placeholder: "Add the emails here ..."
        }, null, 8, ["regex", "modelValue"]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          disabled: _ctx.loading || !_ctx.emails.length,
          class: "btn btn-lg btn-new-design-primary w-180-px",
          style: {"margin-left":"36px"},
          "data-kt-indicator": _ctx.loading ? 'on' : null
        }, _hoisted_8, 8, _hoisted_5)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}